module.exports = __webpack_public_path__ + "static/media/close.3f3221cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/assets/close.svg
// module id = ./src/routes/Home/assets/close.svg
// module chunks = 14